import React, { useRef } from 'react';
import { useDrop, useDrag } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { ElementTemplate } from '../../TemplateComponent';

function CustomDetails({
  col,
  index,
  i,
  dropLocation,
  changePosition,
  dropInLocation,
  fromForm,
  duplicatingItem,
  editingInput,
  eleIndex,
  customData,
  onChange,
  deleteItem,
  elementId,
  fromCustomSection,
}) {
  const customRef = useRef(null);
  const { t } = useTranslation('common');

  const ifNotContainer = (i, index, item) => {
    return item?.col ? changePosition(item, index, i, eleIndex) : dropInLocation(i, index, item, customData?.id, eleIndex);
  };

  const [{ item, handlerId, isOver }, drop] = useDrop({
    accept: ['container', 'item'],
    drop: () => {
      item.type === 'container' ? dropLocation(index, item) : ifNotContainer(i, index, item);
    },
    collect: (monitor) => ({
      item: monitor.getItem(),
      handlerId: monitor.getHandlerId(),
      isOver: monitor.isOver(),
    }),
  });
  const [{ isDragging }, drag] = useDrag({
    type: col?.type,
    item: () => {
      return { col, index, i, eleIndex };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(customRef));

  return (
    <div ref={customRef} style={{ opacity }} data-handler-id={handlerId} key={`${col?.label}_${index}_${i}`}>
      {isOver && <div className="potemplate-drag-placeholder">{t('PO_TEMPLATES.PO_DETAILS.FORM_COMPONENT.CUSTOM_DETAILS.DROP_SECTION_HERE')}</div>}
      <ElementTemplate
        {...col}
        keys={col?.key}
        error={col?.hasError}
        requiredField={col?.required}
        disable={!fromForm}
        options={col?.options}
        placeHolder={col?.placeholder ? `${col?.placeholder}` : `${col?.label}`}
        fromForm={fromForm}
        duplicatingItem={duplicatingItem}
        editingInput={editingInput}
        index={index}
        eleIndex={eleIndex}
        i={i}
        elekey={customData?.key}
        value={col?.value}
        onChange={onChange}
        deleteItem={deleteItem}
        showDelete={col?.addingNew}
        elementId={elementId}
        fromCustomSection={fromCustomSection}
      />
    </div>
  );
}

export default CustomDetails;
